import React from 'react';
import Icon from '../../../components/AppIcon';

const ChemicalInventory = ({ chemicals, searchQuery, activeFilters, onChemicalSelect }) => {
  const filteredChemicals = chemicals?.filter((chem) => {
    const matchesSearch =
      !searchQuery ||
      chem?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      chem?.casNumber?.includes(searchQuery) ||
      chem?.formula?.toLowerCase()?.includes(searchQuery?.toLowerCase());

    const matchesHazardClass =
      activeFilters?.hazardClass?.length === 0 ||
      chem?.hazardClass?.some((h) => activeFilters?.hazardClass?.includes(h));

    const matchesPhysicalState =
      activeFilters?.physicalState?.length === 0 ||
      activeFilters?.physicalState?.includes(chem?.physicalState);

    const matchesRegulatory =
      activeFilters?.regulatoryStatus?.length === 0 ||
      activeFilters?.regulatoryStatus?.includes(chem?.regulatoryStatus);

    return matchesSearch && matchesHazardClass && matchesPhysicalState && matchesRegulatory;
  });

  const getHazardColor = (hazard) => {
    const colorMap = {
      Flammable: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
      Toxic: 'bg-purple-500/10 text-purple-500 border-purple-500/20',
      Corrosive: 'bg-red-500/10 text-red-500 border-red-500/20',
      Carcinogen: 'bg-destructive/10 text-destructive border-destructive/20',
      Irritant: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
      Reactive: 'bg-blue-500/10 text-blue-500 border-blue-500/20'
    };
    return colorMap?.[hazard] || 'bg-muted text-foreground border-border';
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground">Chemical Inventory</h2>
        <p className="text-sm text-muted-foreground mt-1">
          {filteredChemicals?.length || 0} chemical{filteredChemicals?.length !== 1 ? 's' : ''} found
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Chemical Name</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">CAS Number</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Formula</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Hazard Classes</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Status</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filteredChemicals?.map((chemical) => (
              <tr key={chemical?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-4 py-3">
                  <div className="font-medium text-foreground">{chemical?.name}</div>
                  <div className="text-xs text-muted-foreground">Updated: {chemical?.lastUpdated}</div>
                </td>
                <td className="px-4 py-3 text-sm text-foreground">{chemical?.casNumber}</td>
                <td className="px-4 py-3 text-sm font-mono text-foreground">{chemical?.formula}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap gap-1">
                    {chemical?.hazardClass?.map((hazard, idx) => (
                      <span
                        key={idx}
                        className={`text-xs px-2 py-1 rounded border ${getHazardColor(hazard)}`}
                      >
                        {hazard}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`text-xs px-2 py-1 rounded border ${
                      chemical?.regulatoryStatus === 'Highly Regulated' ?'bg-destructive/10 text-destructive border-destructive/20' :'bg-warning/10 text-warning border-warning/20'
                    }`}
                  >
                    {chemical?.regulatoryStatus}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => onChemicalSelect?.(chemical)}
                    className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary/80 transition-colors"
                  >
                    View Details
                    <Icon name="ChevronRight" size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {filteredChemicals?.length === 0 && (
          <div className="p-8 text-center">
            <Icon name="Search" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No chemicals found matching your criteria</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChemicalInventory;